export const calcEipPrice = 'eip/calcEipPrice';
export const updateBandWidth = 'eip/updateBandWidth';
